import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  CustomerRule,
  CustomerRuleName,
  FindCustomersOutput,
  FindCustomersParams,
  PostCustomerFilesOutput,
} from './customers.types';

const PATH = 'customers';

export const findCustomers = (params: FindCustomersParams, signal?: AbortSignal) =>
  restApi.get<FindCustomersOutput>(PATH, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const postCustomerFiles = (files: File[]) => {
  const form = new FormData();

  files.forEach((file) => {
    form.append('files[]', file);
  });

  return restApi.post<PostCustomerFilesOutput[]>(`${PATH}/files`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const findAllCustomerRules = () =>
  restApi.get<CustomerRule<CustomerRuleName>[]>(`customer-rules`);
